import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import About from "../pages/about/page";
import Locations from "../pages/locations/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/locations",
    element: <Locations />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
